import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
  padding: (p) => p.spacing(2, 1),
  background: (p) => p.palette.grey[200],
};
